import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import determinarPaginaAtualReservaBpe from '../../actions/reserva/determinarPaginaAtualReservaBpe'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoReservaBpe extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtualReservaBpe}/>
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualReservaBpe,
    total: state.reservasBpe.reservasBpe.total,
    registrosPorPagina: state.registrosPorPaginaReservaBpe
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtualReservaBpe }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoReservaBpe)
